import { Box } from '@awazevr/design-system.components.box'
import { Divider } from '@awazevr/design-system.components.divider'
import { Stack } from '@awazevr/design-system.components.stack'

type OrComponentProps = {
  label: string
}
export const OrComponent = ({
  label,
}: OrComponentProps): React.ReactElement => {
  return (
    <Stack
      spacing={0}
      align="center"
      justify="space-between"
      fullWidth
      direction="row"
    >
      <Stack spacing={0} fullWidth>
        <Divider margin={0} />
      </Stack>
      <Box
        padding={[
          [0, 36, 0],
          [0, 36, 0],
          [0, 36, 0],
        ]}
      >
        {label}
      </Box>
      <Stack spacing={0} fullWidth>
        <Divider margin={0} />
      </Stack>
    </Stack>
  )
}
